import {
    AdditionalClientContact,
    Client,
    ClientId,
    Community,
    CommunityId,
    CommunityRelationshipType,
    ContactEntityId,
    ContactId,
    FileId,
    IAnswer,
    IClient,
    ICommunity,
    IFile,
    InternalId,
    IQuestion,
    ITenant,
    Maybe,
    mostlyEmptyQuestion,
    parseEntityId,
    PermissionMapping,
    Question,
    QuestionId,
    TenantId,
    User,
} from "@sp-crm/core";
import { QueryClient } from "react-query";
import { Action, Dispatch } from "redux";
import { push } from "util/history";
import "whatwg-fetch";
import * as browser from "../../util/browser";
import { setFavicon } from "../../util/browser";
import { setErrorTrackingContext } from "../../util/error-tracking";
import * as http from "../../util/http";
import { invalidateCommunityQueryCache } from "./communities";
import { loadSignedInUser } from "./session";

export enum Actions {
    UPDATE_SIZE,
    HIDE_MENU,
    SHOW_MENU,
    COUNT_ITEMS_IN_QUESTION_CATEGORY,
    CLEAR_TENANT_SAVE_NOTIFICATION,
    CLEAR_USER_SAVE_NOTIFICATION,
    ADD_COMMUNITY_TO_CLIENT_FINISH,
    ADD_COMMUNITY_TO_CLIENT_START,
    CLIENTS_LIST_SELECT_USER,
    CLIENTS_LIST_SELECT_REFERRAL_USER,
    CLIENTS_LIST_SELECT_COLLABORATOR_USER,
    CLIENT_SEARCH_TEXT,
    CLIENT_SEARCH_TYPE,
    COMMUNITY_SEARCH_CLEAR,
    COMMUNITY_SEARCH_INITIALIZE,
    COMMUNITY_SEARCH_NEXT_PAGE,
    COMMUNITY_SEARCH_PREV_PAGE,
    COMMUNITY_SEARCH_GO_TO_PAGE,
    COMMUNITY_SEARCH_SET_PAGE_SIZE,
    COMMUNITY_SEARCH_UPDATE_SEARCH,
    COMMUNITY_SEARCH_MAP_MOVE,
    COMMUNITY_SEARCH_MAP_RESET,
    DASHBOARD_SORT,
    EULA_TRANSITION,
    EXCLUDE_COMMUNITY_FROM_CLIENT_START,
    EXCLUDE_COMMUNITY_FROM_CLIENT_FINISH,
    UNEXCLUDE_COMMUNITY_FROM_CLIENT_START,
    UNEXCLUDE_COMMUNITY_FROM_CLIENT_FINISH,
    ADD_NO_COMPARE_FROM_CLIENT_START,
    ADD_NO_COMPARE_FROM_CLIENT_FINISH,
    REMOVE_NO_COMPARE_FROM_CLIENT_START,
    REMOVE_NO_COMPARE_FROM_CLIENT_FINISH,
    GEOCODE_FINISH,
    GEOCODE_START,
    LOAD_ALL_CLIENTS_FINISH,
    LOAD_ALL_CLIENTS_START,
    LOAD_COMMUNITIES_PAGE_FINISH,
    LOAD_ALL_COMMUNITIES_FINISH,
    LOAD_COMMUNITIES_PAGE_START,
    LOAD_COMMUNITIES_BY_CLIENT_START,
    LOAD_COMMUNITIES_BY_CLIENT_FINISH,
    LOAD_ALL_TASKS_END,
    LOAD_ALL_TASKS_START,
    LOAD_ALL_TOURS_END,
    LOAD_ALL_TOURS_START,
    LOAD_ALL_USERS_END,
    LOAD_ALL_USERS_START,
    LOAD_CLIENT_FINISH,
    LOAD_CLIENT_START,
    LOAD_COMMUNITY_FINISH,
    LOAD_COMMUNITY_START,
    LOAD_QUESTION_START,
    LOAD_QUESTION_FINISH,
    LOAD_SETTINGS_FINISH,
    LOAD_SETTINGS_START,
    LOAD_TENANT_START,
    LOAD_TENANT_FINISH,
    LOGIN_FAIL,
    LOGIN_FINISH,
    LOGIN_START,
    LOGIN_REQUIRES_2FA,
    LOGOUT,
    REMOVE_COMMUNITY_FROM_CLIENT_FINISH,
    REMOVE_COMMUNITY_FROM_CLIENT_START,
    SAVE_NEW_CLIENT_FINISH,
    SAVE_CLIENT_NEW_CONTACT_PERSON_START,
    SAVE_CLIENT_NEW_CONTACT_PERSON_FINISH,
    UPDATE_CLIENT_CONTACT_PERSON_START,
    UPDATE_CLIENT_CONTACT_PERSON_FINISH,
    DELETE_CLIENT_CONTACT_PERSON_START,
    DELETE_CLIENT_CONTACT_PERSON_FINISH,
    UPDATE_CLIENT_COMMUNITY_ORDER,
    SAVE_NEW_QUESTION_START,
    SAVE_NEW_QUESTION_FINISH,
    SAVE_NEW_QUESTION_FAIL,
    SAVE_NEW_CLIENT_START,
    SAVE_NEW_COMMUNITY_CONTACT_FINISH,
    SAVE_NEW_COMMUNITY_CONTACT_START,
    SAVE_NEW_COMMUNITY_FINISH,
    SAVE_NEW_COMMUNITY_PHOTOS_START,
    SAVE_NEW_COMMUNITY_PHOTOS_FINISH,
    SAVE_NEW_EVERGREEN_LISTING_PHOTOS_START,
    SAVE_NEW_EVERGREEN_LISTING_PHOTOS_FINISH,
    SAVE_NEW_COMMUNITY_START,
    SAVE_NEW_TASK_FINISH,
    SAVE_NEW_TASK_START,
    SAVE_NEW_TOUR_FINISH,
    SAVE_NEW_TOUR_START,
    SAVE_SETTINGS_FINISH,
    SAVE_SETTINGS_START,
    REPORT_PARAMETER_CLIENT_PLACEMENT_START_DATE_UPDATE,
    REPORT_PARAMETER_CLIENT_PLACEMENT_END_DATE_UPDATE,
    REPORT_PARAMETER_CLIENT_PLACEMENT_SHOW_PER_USER_UPDATE,
    REPORT_PARAMETER_SUMMARY_START_DATE_UPDATE,
    REPORT_PARAMETER_SUMMARY_END_DATE_UPDATE,
    REPORT_PARAMETER_CUSTOM_NEW_REPORT_INPUT_UPDATE,
    DELETE_SETTING_START,
    DELETE_SETTING_FINISH,
    TICK,
    HEARTBEAT,
    MODIFY_UNSAVED_QUESTION,
    UPDATE_CLIENT_FINISH,
    UPDATE_CLIENT_REFERRAL_SOURCE,
    UPDATE_CLIENT_START,
    UPDATE_COMMUNITY_CONTACT_FINISH,
    UPDATE_COMMUNITY_CONTACT_START,
    DELETE_COMMUNITY_CONTACT_START,
    DELETE_COMMUNITY_CONTACT_FINISH,
    UPDATE_COMMUNITY_FINISH,
    UPDATE_COMMUNITY_PHOTOS_START,
    UPDATE_COMMUNITY_PHOTOS_FINISH,
    DELETE_COMMUNITY_PHOTOS_START,
    DELETE_COMMUNITY_PHOTOS_FINISH,
    UPDATE_COMMUNITY_START,
    UPDATE_TASK_FINISH,
    UPDATE_TASK_START,
    UPDATE_TENANT_FINISH,
    UPDATE_TENANT_START,
    UPDATE_TOUR_FINISH,
    UPDATE_TOUR_START,
    UPDATE_USER_FINISH,
    UPDATE_USER_START,
    UPDATE_SETTINGS_START,
    UPDATE_SETTINGS_FINISH,
    UPDATE_SETTINGS_FAIL,
    SELECT_CONTACT,
    LOAD_SINGLE_QUESTION,
    DESTROY_SINGLE_QUESTION,
    DELETE_COMMUNITY_SELECTED_CONTACT,
    DELETE_TASK,
    //PDF
    DOWNLOAD_COMMUNITY_COMPARISON_PDF_START,
    DOWNLOAD_COMMUNITY_COMPARISON_PDF_FINISH,
    DOWNLOAD_COMMUNITY_COMPARISON_PDF_ERROR,
    DOWNLOAD_CLIENT_REFERRAL_PDF_START,
    DOWNLOAD_CLIENT_REFERRAL_PDF_FINISH,
    DOWNLOAD_CLIENT_REFERRAL_PDF_ERROR,
    // email form
    EMAIL_FORM_INIT,
    EMAIL_FORM_SUBMIT,
    EMAIL_FORM_ERROR,
    EMAIL_FORM_SUCCESS,
    EMAIL_FORM_VALUE_CHANGE,
    EMAIL_FORM_VALUE_CLEAR,
    EMAIL_FORM_TEMPLATE_INIT,
    RESET_PASSWORD_START,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILED,
    RESET_PASSWORD_REQUIRES_2FA,
    RESET_PASSWORD_CLEAR_2FA,
    SET_PASSWORD_START,
    SET_PASSWORD_SUCCESS,
    SET_PASSWORD_FAILED,
    REQUEST_FAIL,
    REQUEST_FAIL_ACKNOWLEDGE,
    REQUEST_UNAUTHORIZED,
    REQUEST_UNAUTHORIZED_ACKNOWLEDGE,
    // FILES
    LOAD_FILES_START,
    LOAD_FILES_FINISH,
    UPLOAD_FILE,
    UPDATE_FILE_START,
    UPDATE_FILE_FINISH,
    CLEAR_FILE_CACHE,
    // REGIONS
    SELECT_REGION,
    LOAD_PERMISSIONS_START,
    LOAD_PERMISSIONS_FINISH,
    REACTIVATE_CLIENT_START,
    REACTIVATE_CLIENT_FINISH,
    LOAD_REFERRALS_FINISH,
    LOAD_REFERRALS_START,
    UPDATE_REFERRAL_FINISH,
    UPDATE_REFERRAL_START,
    CREATE_REFERRAL_FINISH,
    CREATE_REFERRAL_START,
    DELETE_REFERRAL_FINISH,
    DELETE_REFERRAL_START,
    OPEN_REFERRAL_EDIT,
    // EMAILS SENT
    LOAD_EMAILS_SENT_FINISH,
    LOAD_EMAILS_SENT_START,
    OPEN_EMAIL_PREVIEW,
    CLOSE_EMAIL_PREVIEW,
    LOAD_GUEST_COMMUNITY_COMPARISON_START,
    LOAD_GUEST_COMMUNITY_COMPARISON_FINISH,
    GLOBAL_SUCCESS_NOTIFY,
    GLOBAL_SUCCESS_CLEAR,
}

export function getAndDispatchActionsWithAPIPayload<T>(
    dispatch: Dispatch<Action>,
    method: string,
    route: string,
    path: string,
    startType: Actions,
    endType: Actions,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    callback: (v: T) => any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    payload?: any,
): Promise<T> {
    dispatch({ type: Actions[startType] });
    const requestDescription = http.newRequestDescription(route);
    return (
        http
            .send(requestDescription, method, path, payload)
            .then(r => r.data)
            .then((responseData: T) => {
                const payload = callback(responseData);
                dispatch({
                    ...payload,
                    type: Actions[endType],
                });
                return responseData;
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            .catch(r => http.errorHandler(r, requestDescription, dispatch) as any)
    );
}

export function navigate(path: string): void {
    push(path);
}

export function saveNewCommunity(
    newCommunity: Community,
    dispatch: Dispatch<Action>,
): void {
    dispatch({ type: Actions[Actions.SAVE_NEW_COMMUNITY_START] });
    const requestDescription = http.newRequestDescription("/api/communities");
    http.post(requestDescription, "/api/communities", newCommunity)
        .then(r => r.data)
        .then((responseData: Community) => {
            dispatch({
                type: Actions[Actions.SAVE_NEW_COMMUNITY_FINISH],
                community: responseData,
            });
            return responseData;
        })
        .then((responseData: Community) => {
            push("/communities/show/" + responseData.id);
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function updateCommunityClientNotes(
    clientId: ClientId,
    communityId: CommunityId,
    noteType: "private" | "public",
    notes: string,
    dispatch: Dispatch<Action>,
): Promise<void | IClient> {
    dispatch({
        type: Actions[Actions.ADD_COMMUNITY_TO_CLIENT_START],
        communityId,
        clientId,
    });
    const requestDescription = http.newRequestDescription(
        "/api/clients/:id/communities/:id/notes",
    );

    return http
        .put(
            requestDescription,
            `/api/clients/${clientId}/communities/${communityId}/notes`,
            {
                notes,
                noteType,
            },
        )
        .then(r => r.data)
        .then((responseData: IClient) => {
            dispatch({
                type: Actions[Actions.ADD_COMMUNITY_TO_CLIENT_FINISH],
                client: responseData,
                when: new Date(),
            });

            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function updateCommunityClient(
    clientId: ClientId,
    communityId: CommunityId,
    relationship: CommunityRelationshipType,
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    dispatch({
        type: Actions[Actions.ADD_COMMUNITY_TO_CLIENT_START],
        communityId,
        clientId,
    });
    const requestDescription = http.newRequestDescription(
        "/api/clients/:id/communities/:id",
    );

    return http
        .put(requestDescription, `/api/clients/${clientId}/communities/${communityId}`, {
            relationship: relationship,
        })
        .then(r => r.data)
        .then((responseData: IClient) => {
            dispatch({
                type: Actions[Actions.ADD_COMMUNITY_TO_CLIENT_FINISH],
                client: responseData,
                when: new Date(),
            });
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function removeCommunityFromClient(
    clientId: ClientId,
    communityId: CommunityId,
    dispatch: Dispatch<Action>,
): Promise<IClient | void> {
    dispatch({
        type: Actions[Actions.REMOVE_COMMUNITY_FROM_CLIENT_START],
        communityId,
        clientId,
    });
    const requestDescription = http.newRequestDescription(
        "/api/clients/:id/communities/:id",
    );
    return http
        .deleteReq(
            requestDescription,
            `/api/clients/${clientId}/communities/${communityId}`,
        )
        .then(r => r.data)
        .then((responseData: IClient) => {
            dispatch({
                type: Actions[Actions.REMOVE_COMMUNITY_FROM_CLIENT_FINISH],
                client: responseData,
            });
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function addCommunityPhotos(
    communityId: CommunityId,
    photos: File[],
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    dispatch({
        type: Actions[Actions.SAVE_NEW_COMMUNITY_PHOTOS_START],
        communityId: communityId,
    });

    const formData = new FormData();
    photos.forEach(photo => formData.append("photos", photo));

    const requestDescription = http.newRequestDescription("/api/communities/:id/photos");
    return http
        .post(requestDescription, `/api/communities/${communityId}/photos`, formData, {
            "Content-Type": "multipart/form-data",
        })
        .then(r => r.data)
        .then((responseData: { community: ICommunity }) => {
            dispatch({
                type: Actions[Actions.SAVE_NEW_COMMUNITY_PHOTOS_FINISH],
                community: responseData.community,
            });
        })
        .catch(r => {
            http.errorHandler(r, requestDescription, dispatch);
            throw r;
        });
}

function updateCommunityPhotoHelper(
    communityId: CommunityId,
    photoId: FileId,
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    payload: any,
) {
    const requestDescription = http.newRequestDescription(
        "/api/communities/:id/photos/:id",
    );
    return http
        .put(
            requestDescription,
            `/api/communities/${communityId}/photos/${photoId}`,
            payload,
        )
        .then(r => r.data)
        .then((responseData: { community: ICommunity }) => {
            dispatch({
                type: Actions[Actions.UPDATE_COMMUNITY_PHOTOS_FINISH],
                community: responseData.community,
            });
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function updateCommunityPhoto(
    communityId: CommunityId,
    photoId: FileId,
    newPhoto: File,
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    dispatch({
        type: Actions[Actions.UPDATE_COMMUNITY_PHOTOS_START],
        communityId: communityId,
    });

    const formData = new FormData();
    formData.append("photo", newPhoto);

    return updateCommunityPhotoHelper(communityId, photoId, dispatch, formData);
}

export function updateCommunityPhotoDescription(
    communityId: CommunityId,
    photoId: FileId,
    description: string,
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    dispatch({
        type: Actions[Actions.UPDATE_COMMUNITY_PHOTOS_START],
        communityId: communityId,
    });

    return updateCommunityPhotoHelper(communityId, photoId, dispatch, { description });
}

export function updateCommunityPhotos(
    communityId: CommunityId,
    photos: Partial<IFile>[],
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    dispatch({
        type: Actions[Actions.UPDATE_COMMUNITY_PHOTOS_START],
        communityId: communityId,
    });

    const requestDescription = http.newRequestDescription("/api/communities/:id/photos");
    return http
        .put(requestDescription, `/api/communities/${communityId}/photos`, photos)
        .then(r => r.data)
        .then((responseData: { community: ICommunity }) => {
            dispatch({
                type: Actions[Actions.UPDATE_COMMUNITY_PHOTOS_FINISH],
                community: responseData.community,
            });
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function deleteCommunityPhoto(
    communityId: CommunityId,
    photoId: FileId,
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    dispatch({
        type: Actions[Actions.UPDATE_COMMUNITY_PHOTOS_START],
        communityId: communityId,
    });

    const requestDescription = http.newRequestDescription(
        "/api/communities/:id/photos/:id",
    );
    return http
        .deleteReq(
            requestDescription,
            `/api/communities/${communityId}/photos/${photoId}`,
        )
        .then(r => r.data)
        .then((responseData: { community: ICommunity }) => {
            dispatch({
                type: Actions[Actions.UPDATE_COMMUNITY_PHOTOS_FINISH],
                community: responseData.community,
            });
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export async function addAdditionalClientPhysicianContact(
    clientId: ClientId,
    additionalClientId: InternalId,
    payload: Partial<AdditionalClientContact>,
    dispatch: Dispatch<Action>,
): Promise<{ client: IClient; newContactId: ContactId } | null> {
    dispatch({
        type: Actions[Actions.SAVE_CLIENT_NEW_CONTACT_PERSON_START],
        clientId: clientId,
    });
    const requestDescription = http.newRequestDescription(
        "/api/clients/:id/additionalClients/:id/physicianContacts",
    );
    return http
        .post(
            requestDescription,
            `/api/clients/${clientId}/additionalClients/${additionalClientId}/physicianContacts`,
            payload,
        )
        .then(r => r.data)
        .then((responseData: { client: IClient; newContactId: ContactId }) => {
            dispatch({
                type: Actions[Actions.SAVE_CLIENT_NEW_CONTACT_PERSON_FINISH],
                client: responseData.client,
                newContactId: responseData.newContactId,
            });
            return responseData;
        })
        .catch((r): null => {
            http.errorHandler(r, requestDescription, dispatch);
            return null;
        });
}

export function updateAdditionalClientContactPerson(
    clientId: ClientId,
    additionalClientId: InternalId,
    contactId: ContactId,
    contact: AdditionalClientContact,
    dispatch: Dispatch<Action>,
): void {
    dispatch({
        type: Actions[Actions.UPDATE_CLIENT_CONTACT_PERSON_START],
        clientId,
        contactId,
        text: contact,
    });
    const payload = contact;
    const requestDescription = http.newRequestDescription(
        "/api/clients/:id/additionalClients/:id/physicianContacts/:id",
    );
    http.put(
        requestDescription,
        `/api/clients/${clientId}/additionalClients/${additionalClientId}/physicianContacts/${contactId}`,
        payload,
    )
        .then(r => r.data)
        .then((responseData: IClient) => {
            dispatch({
                type: Actions[Actions.UPDATE_CLIENT_CONTACT_PERSON_FINISH],
                client: responseData,
            });
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function deleteAdditionalClientContactPerson(
    clientId: ClientId,
    additionalClientId: InternalId,
    contactId: ContactId,
    dispatch: Dispatch<Action>,
): void {
    dispatch({
        type: Actions[Actions.DELETE_CLIENT_CONTACT_PERSON_START],
        clientId,
        contactId,
    });
    const requestDescription = http.newRequestDescription(
        "/api/clients/:id/additionalClients/:id/physicianContacts/:id",
    );
    http.deleteReq(
        requestDescription,
        `/api/clients/${clientId}/additionalClients/${additionalClientId}/physicianContacts/${contactId}`,
    )
        .then(r => r.data)
        .then((responseData: IClient) => {
            dispatch({
                type: Actions[Actions.DELETE_CLIENT_CONTACT_PERSON_FINISH],
                client: responseData,
            });

            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function updateUser(user: User, dispatch: Dispatch<Action>): Promise<unknown> {
    dispatch({ type: Actions[Actions.UPDATE_USER_START] });
    const requestDescription = http.newRequestDescription("/api/user");
    return http
        .put(requestDescription, `/api/user`, user)
        .then(r => r.data)
        .then((responseData: User) => {
            dispatch({
                type: Actions[Actions.UPDATE_USER_FINISH],
                user: responseData,
            });
            setTimeout(
                () =>
                    dispatch({
                        type: Actions[Actions.CLEAR_USER_SAVE_NOTIFICATION],
                    }),
                5000,
            );
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function updateTenant(tenant: ITenant, dispatch: Dispatch<Action>): void {
    getAndDispatchActionsWithAPIPayload(
        dispatch,
        "PUT",
        "/api/tenants/:id",
        `/api/tenants/${tenant.tenantId}`,
        Actions.UPDATE_TENANT_START,
        Actions.UPDATE_TENANT_FINISH,
        (responseData: ITenant) => ({ tenant: responseData }),
        tenant,
    ).then(() => {
        setTimeout(
            () =>
                dispatch({
                    type: Actions[Actions.CLEAR_TENANT_SAVE_NOTIFICATION],
                }),
            5000,
        );
    });
}

export async function createQuestion(
    order: number,
    queryClient: QueryClient,
    dispatch: Dispatch<Action>,
): Promise<void> {
    try {
        dispatch({ type: Actions[Actions.SAVE_NEW_QUESTION_START] });

        const question = mostlyEmptyQuestion(order).asJson;

        const requestDescription = http.newRequestDescription("/api/questions");
        const response = await http
            .post<IQuestion>(requestDescription, "/api/questions", question)
            .then(r => r.data)
            .catch(r => http.errorHandler(r, requestDescription, dispatch));

        const q = Question.load(response);
        dispatch({
            type: Actions[Actions.UPDATE_SETTINGS_FINISH],
            question: q,
        });

        push(`/settings/agency/customize/cc/${q.id}`);
        refetchBridgeEntityTypes(queryClient);
    } catch (err) {
        dispatch({
            type: Actions[Actions.SAVE_NEW_QUESTION_FAIL],
            errorType: err.message.toLowerCase(),
        });
    }
}

export function updateSettings(
    question: IQuestion,
    queryClient: QueryClient,
    dispatch: Dispatch<Action>,
): Promise<void | IQuestion> {
    dispatch({ type: Actions[Actions.UPDATE_SETTINGS_START] });
    const requestDescription = http.newRequestDescription("/api/questions/:id");
    return http
        .put(requestDescription, `/api/questions/${question.id}`, question.asJson)
        .then(r => r.data)
        .then(q => Question.load(q))
        .then((q: IQuestion) => {
            dispatch({
                type: Actions[Actions.UPDATE_SETTINGS_FINISH],
                question: q,
            });
            refetchBridgeEntityTypes(queryClient);
            return q;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function deleteQuestion(
    questionId: QuestionId,
    queryClient: QueryClient,
    dispatch: Dispatch<Action>,
): Promise<void | Question[]> {
    const requestDescription = http.newRequestDescription("/api/questions/:id");
    return http
        .deleteReq(requestDescription, `/api/questions/${questionId}`)
        .then((): null => {
            dispatch({
                type: Actions[Actions.DELETE_SETTING_FINISH],
                questionId,
            });
            refetchBridgeEntityTypes(queryClient);
            return null;
        })
        .catch((r): void => http.errorHandler(r, requestDescription, dispatch));
}

export function updateCommunityFields(
    communityId: CommunityId,
    changes: Record<string, unknown>,
    queryClient: QueryClient,
    dispatch: Dispatch<Action>,
): void {
    updateCommunityFieldsPromise(communityId, changes, queryClient, dispatch);
}

export async function updateCommunityFieldsPromise(
    communityId: CommunityId,
    changes: Record<string, unknown>,
    queryClient: QueryClient,
    dispatch: Dispatch<Action>,
): Promise<Community | void> {
    dispatch({ type: Actions[Actions.UPDATE_COMMUNITY_START] });
    const requestDescription = http.newRequestDescription("/api/communities/:id");
    return http
        .put(requestDescription, `/api/communities/${communityId}`, changes)
        .then(r => r.data)
        .then((responseData: Community) => {
            dispatch({
                type: Actions[Actions.UPDATE_COMMUNITY_FINISH],
                community: responseData,
            });
            invalidateCommunityQueryCache(queryClient);
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export async function updateCommunity(
    communityId: CommunityId,
    fieldName: string,
    newValue: unknown,
    queryClient: QueryClient,
    dispatch: Dispatch<Action>,
): Promise<void> {
    await updateCommunityPromise(communityId, fieldName, newValue, queryClient, dispatch);
}

export async function updateCommunityPromise(
    communityId: CommunityId,
    fieldName: string,
    newValue: unknown,
    queryClient: QueryClient,
    dispatch: Dispatch<Action>,
): Promise<void> {
    dispatch({ type: Actions[Actions.UPDATE_COMMUNITY_START] });
    const payload = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    (payload as any)[fieldName] = newValue ?? null;
    const requestDescription = http.newRequestDescription("/api/communities/:id");
    try {
        const result = await http.put(
            requestDescription,
            `/api/communities/${communityId}`,
            payload,
        );
        const data = result.data;
        invalidateCommunityQueryCache(queryClient);
        dispatch({
            type: Actions[Actions.UPDATE_COMMUNITY_FINISH],
            community: data,
        });
    } catch (r) {
        http.errorHandler(r, requestDescription, dispatch);
    }
}

export function updateClientMultiField(
    clientId: ClientId,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    newValues: any,
    dispatch: Dispatch<Action>,
): void {
    updateClientMultiFieldPromise(clientId, newValues, dispatch);
}

export function updateClientMultiFieldPromise(
    clientId: ClientId,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    newValues: any,
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    const requestDescription = http.newRequestDescription("/api/clients/:id");
    return http
        .put(requestDescription, `/api/clients/${clientId}`, newValues)
        .then(r => r.data)
        .then((responseData: Client) => {
            dispatch({
                type: Actions[Actions.UPDATE_CLIENT_FINISH],
                client: responseData,
                when: new Date(),
            });
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function updateClientAnswer(
    clientId: ClientId,
    answer: IAnswer,
    dispatch: Dispatch<Action>,
): Promise<void | IAnswer> {
    dispatch({ type: Actions[Actions.UPDATE_CLIENT_START] });
    const requestDescription = http.newRequestDescription("/api/clients/:id/answers");
    return (
        http
            .put(requestDescription, `/api/clients/${clientId}/answers`, answer)
            .then(r => r.data)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            .then((responseData: any) => {
                dispatch({
                    type: Actions[Actions.UPDATE_CLIENT_FINISH],
                    client: responseData,
                    when: new Date(),
                });
                return responseData;
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            .then((data: any) => Client.load(data))
            .then(c => c.answers.find(a => a.questionId === answer.questionId))
            .catch(r => http.errorHandler(r, requestDescription, dispatch))
    );
}

export function updateAdditionalClientAnswer(
    clientId: ClientId,
    additionalClientId: InternalId,
    answer: IAnswer,
    dispatch: Dispatch<Action>,
): Promise<void | IAnswer> {
    dispatch({ type: Actions[Actions.UPDATE_CLIENT_START] });
    const requestDescription = http.newRequestDescription(
        "/api/clients/:id/additionalClients/:id/answers",
    );
    return (
        http
            .put(
                requestDescription,
                `/api/clients/${clientId}/additionalClients/${additionalClientId}/answers`,
                answer,
            )
            .then(r => r.data)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            .then((responseData: any) => {
                dispatch({
                    type: Actions[Actions.UPDATE_CLIENT_FINISH],
                    client: responseData,
                    when: new Date(),
                });
                return responseData;
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            .then((data: any) => Client.load(data))
            .then(c =>
                c.additionalClient.answers.find(a => a.questionId === answer.questionId),
            )
            .catch(r => http.errorHandler(r, requestDescription, dispatch))
    );
}

export function updateCommunityAnswer(
    communityId: CommunityId,
    answer: IAnswer,
    queryClient: QueryClient,
    dispatch: Dispatch<Action>,
): Promise<void | IAnswer> {
    dispatch({ type: Actions[Actions.UPDATE_COMMUNITY_START] });
    const requestDescription = http.newRequestDescription("/api/communities/:id/answers");
    return (
        http
            .put(requestDescription, `/api/communities/${communityId}/answers`, answer)
            .then(r => r.data)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            .then((responseData: any) => {
                dispatch({
                    type: Actions[Actions.UPDATE_COMMUNITY_FINISH],
                    community: responseData,
                });
                invalidateCommunityQueryCache(queryClient);
                return responseData;
            })
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            .then((data: any) => Community.load(data))
            .then(c => c.answers.find(a => a.questionId === answer.questionId))
            .catch(r => http.errorHandler(r, requestDescription, dispatch))
    );
}

export function updateClient(
    clientId: ClientId,
    fieldName: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    newValue: any,
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    return updateClientPromise(clientId, fieldName, newValue, dispatch);
}

export function updateClientPromise(
    clientId: ClientId,
    fieldName: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    newValue: any,
    dispatch: Dispatch<Action>,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
): Promise<any> {
    dispatch({ type: Actions[Actions.UPDATE_CLIENT_START] });
    const payload = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    (payload as any)[fieldName] = newValue;
    return updateClientMultiFieldPromise(clientId, payload, dispatch);
}

export function loadCommunity(
    communityId: CommunityId,
    dispatch: Dispatch<Action>,
): void {
    dispatch({ type: Actions[Actions.LOAD_COMMUNITY_START] });
    const path = `/api/communities/${communityId}`;
    const requestDescription = http.newRequestDescription("/api/communities/:id");
    http.get(requestDescription, path)
        .then(r => r.data)
        .then((responseData: Community) => {
            dispatch({
                type: Actions[Actions.LOAD_COMMUNITY_FINISH],
                community: responseData,
            });
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

export function loadClient(clientId: ClientId, dispatch: Dispatch<Action>): void {
    dispatch({ type: Actions[Actions.LOAD_CLIENT_START], clientId });
    const path = `/api/clients/${clientId}`;
    const requestDescription = http.newRequestDescription("/api/clients/:id");
    http.get(requestDescription, path)
        .then(r => r.data)
        .then((responseData: Client) => {
            dispatch({
                type: Actions[Actions.LOAD_CLIENT_FINISH],
                client: responseData,
                when: new Date(),
            });
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
export function loadSettings(dispatch: Dispatch<Action>): Promise<any> {
    dispatch({ type: Actions[Actions.LOAD_SETTINGS_START] });
    const requestDescription = http.newRequestDescription("/api/questions");
    return http
        .get(requestDescription, "/api/questions")
        .then(r => r.data)
        .then((responseData: IQuestion[]) => {
            const allSettings = responseData.map(rawQ => Question.load(rawQ));
            dispatch({
                type: Actions[Actions.LOAD_SETTINGS_FINISH],
                settings: allSettings,
            });
            return responseData;
        })
        .catch(r => http.errorHandler(r, requestDescription, dispatch));
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
export function loadPermissions(dispatch: Dispatch<Action>): Promise<any> {
    return getAndDispatchActionsWithAPIPayload(
        dispatch,
        "GET",
        "/api/permissions",
        "/api/permissions",
        Actions.LOAD_PERMISSIONS_START,
        Actions.LOAD_PERMISSIONS_FINISH,
        (responseData: PermissionMapping) => {
            setTimeout(() => {
                const userId = Maybe.fromValue(responseData)
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
                    .map(x => (x as any).user)
                    .map(x => x.id)
                    .getOrElse("unknown");
                setErrorTrackingContext({ userId: userId });
            }, 1);
            const advancedMode = Maybe.fromValue(responseData)
                // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
                .map(x => (x as any).etc)
                .map(x => x.shouldUseAdvancedMode)
                .getOrElse(false);
            if (advancedMode) {
                browser.enabledAdvancedMode();
            }
            return { data: responseData };
        },
    );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
export async function loadTenant(dispatch: Dispatch<Action>): Promise<any> {
    return await getAndDispatchActionsWithAPIPayload(
        dispatch,
        "GET",
        "/api/tenant",
        "/api/tenant",
        Actions.LOAD_TENANT_START,
        Actions.LOAD_TENANT_FINISH,
        (responseData: ITenant) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            if ((responseData as any).hasFavicon) {
                setTimeout(() => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
                    setFavicon(`/api/tenants/${(responseData as any).id}/favicon`);
                }, 1);
            }
            setTimeout(() => {
                const id = Maybe.fromValue(responseData)
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
                    .map(x => (x as any).id)
                    .getOrElse(null);

                const parsedIdOrUnknown =
                    typeof id === "string" ? parseEntityId<TenantId>(id) : null;

                setErrorTrackingContext({ tenantId: parsedIdOrUnknown });
            }, 1);
            return { tenant: responseData };
        },
    );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
export function loadAllUsers(dispatch: Dispatch<Action>): Promise<any> {
    dispatch({ type: Actions[Actions.LOAD_ALL_USERS_START] });
    const requestDescription = http.newRequestDescription("/api/users");
    return (
        http
            .get(requestDescription, "/api/users")
            .then(r => r.data)
            // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
            .then((responseData: any[]) => {
                dispatch({
                    type: Actions[Actions.LOAD_ALL_USERS_END],
                    users: responseData,
                });
                return responseData;
            })
            .catch(r => http.errorHandler(r, requestDescription, dispatch))
    );
}

export async function loadAll(
    queryClient: QueryClient,
    dispatch: Dispatch<Action>,
): Promise<void> {
    queryClient.clear();
    loadSignedInUser(dispatch);
    const tenantPromise = loadTenant(dispatch);
    loadSettings(dispatch);
    await tenantPromise;
    loadAllUsers(dispatch);
    loadPermissions(dispatch);
}

export function startTicks(dispatch: Dispatch<Action>): void {
    dispatch({ type: Actions[Actions.TICK], now: new Date() });
    setInterval(() => {
        dispatch({ type: Actions[Actions.TICK], now: new Date() });
    }, 1000 * 120);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
export function selectContact(parentId: ContactEntityId, contactId: ContactId): any {
    return {
        type: Actions[Actions.SELECT_CONTACT],
        parentId,
        contactId,
    };
}

export function refetchReminders(queryClient: QueryClient) {
    if (queryClient.getQueryCache().find("getReminders")) {
        queryClient.invalidateQueries("getReminders", { exact: true });
    }
}

function refetchBridgeEntityTypes(queryClient: QueryClient) {
    queryClient
        .getQueryCache()
        .findAll(["getEntities"])
        .forEach(q => {
            q.fetch();
        });
}
